export enum COMPONENT_TYPES {
  // ToolsWidget = "ToolCard",
  BannerInfo = "BannerPlaceholder",
  Glance = "Glance",
  Index = "Index",
  RelatedArticles = "ArticlesByCatPilClu",
  ContentTitleDescription = "ContentTitleDescription",
  AudioWidget = "AudioWidget",
  ContentDescription = "ContentDescription",
  FAQ = "FaqListWithTitle",
}
